<template>
<div v-if="this.$store.state.is_auth">
	<!-- если нет никаких ошибок -->
	<template v-if="!form_ErrorMessage">

	<!-- поле поиска в QA -->
	<h4 class="qa-search-field-title">{{ 'qa/any_questions' | ftc }}</h4>
	<div class="support-block-wrapper search">		
		<Field
			:isVisibleRow="true"
			crud="qa"
			action="list"
			name="qaSearch"
			ref="qaSearch"
			v-model="qaSearchValue"
			:Field="{ _field_name: 'qaSearch', type: 'text', title: 'main/qa_search', '_visible': true }"
			:removeRightPadding="true"
			:clearButton="true" @event_ClearButtonClicked="qaSearchEvent"
			:bigButton="true" :bigButtonTitle="'main/ask'"
			@enterKeyDown="qaSearchStart"
			@event_Input="onTextEvent" />
	</div>

	<br>
	
	<!-- облако тегов -->
	<h4 class="qa-tags-cloud-title">{{ 'qa/popular_topics' | ftc }}</h4>
	<div v-if="tagList" class="support-tag-cloud">
		<div v-for="tag in tagList" class="tag">
			<a :href="QAURL + '/tags/' + encodeURIComponent(tag.tag)" target="_blank">{{ tag.tag }}</a>
		</div>
	</div>

	<br>
		
	<!-- списки вопросов -->
	<div class="support-block-wrapper">

		<div v-if="popList" class="support-block-questions first">
			<h4>{{ 'qa/pop_questions' | ftc }}</h4>
			<ul>
				<li v-for="link in popList">
					<a :href="QAURL + '/q/' + link.url" target="_blank">{{ link.cap }}</a>
				</li>
			</ul>
		</div>

		<div v-if="newList" class="support-block-questions">
			<h4>{{ 'qa/new_questions' | ftc }}</h4>
			<ul>
				<li v-for="link in newList">
					<a :href="QAURL + '/q/' + link.url" target="_blank">{{ link.cap }}</a>
				</li>
			</ul>
		</div>

	</div>

	<br>

	<!-- нижние кнопки -->
	<div class="support-block-wrapper">
		<router-link to="/ticket/create" class="w5-support-link">
			<font-awesome-icon icon="question-circle" />
			<span class="header">{{ 'qa/ticket_question' | ftc }}</span>
			<span class="link-title">{{ 'qa/create_ticket' | ftc }}</span>
		</router-link>
	</div>

	</template>
</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Vue from 'vue'
import Field from '@/components/elements/formfield'
import Helper from '@/helper/helper.js'
import { EventBus } from '@/bus.js'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'QA',
	//=========================================================================
	// локальные переменные компонента
	//=========================================================================
	data: function() {
		return {
			popList: null,
			newList: null,
			tagList: null,
			qaSearchValue: ''
		}
	},
	//=========================================================================
	// вычисляемые переменные
	//=========================================================================
	computed: {
		currentLang() {
			return this.$store.state.lang
		},
		QAURL() {
			if (Vue.AppName === 'vdsina.com')
			{
				return Vue.AppServerUrl +
					(this.$store.state.lang === 'en' ? '/' : '/ru/') +
					'qa'
			}

			return Vue.QAUrl
		}
	},
	//=========================================================================
	// компонент создан
	//=========================================================================
	created() {
		// только для клиентов
		if (this.$store.state.user_type !== 'client')
		{
			// редирект страницу 404
			return this.$router.push('/404')
		}

		// получим данные
		this.requestData()
	},
	//=========================================================================
	// методы компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// запрос данных
		//---------------------------------------------------------------------
		requestData() {
			// сначала проверим кеш
			if (this.$store.state.qaCache.time && this.$store.state.qaCache.time > Helper.unixTime())
			{
				this.popList = this.$store.state.qaCache.popList
				this.newList = this.$store.state.qaCache.newList
				this.tagList = this.$store.state.qaCache.tagList
				return
			}

			// URL по умолчанию
			let _url = this.QAURL + '/api2panel/list'

			// производим сам запрос формы
			this.$http.get(_url).then(
				// успешно получили данные
				res => {
					if (res && typeof res === 'object' && res.ok === true && res.body &&
						res.body.pop && res.body.new)
					{
						// запоминаем в локальных переменных
						this.$set(this, 'popList', res.body.pop)
						this.$set(this, 'newList', res.body.new)
						this.$set(this, 'tagList', res.body.tag)

						// запоминиаем в кеше
						this.$store.commit('setQACache', {
							popList: this.popList,
							newList: this.newList,
							tagList: this.tagList
						})
					}
				}
			)
		},
		//---------------------------------------------------------------------
		// очистка поля поиска
		//---------------------------------------------------------------------
		qaSearchEvent() {
			// чистим поле
			this.qaSearchValue = ''
			// чистим результаты поиска
			EventBus.$emit('form-ticket-serach-result', false)
		},
		//---------------------------------------------------------------------
		// инициировали старт поиска в QA
		//---------------------------------------------------------------------
		qaSearchStart() {
			// если пустое значение - нечего искать
			if (!this.qaSearchValue || this.qaSearchValue.trim() === '') return

			// запоминиаем себе строку поиска
			let _str = this.qaSearchValue
			// и сразу чистим ее
			this.qaSearchEvent()

			// открываем окно с поиском
			let _win = window.open(this.QAURL + '/search?search=' + encodeURIComponent(_str), '_blank')
			_win.focus()
		},
		//---------------------------------------------------------------------
		// изменение текстового поля с задержкой
		//---------------------------------------------------------------------
		onTextEvent(txt) {
			// это создание тикета клиентом - нужен поиск по QA
			if (this.$store.state.user_type === 'client')
			{
				// сразу проверка
				if (!txt || String(txt).length < 3)
				{
					EventBus.$emit('form-ticket-serach-result', false)
					return
				}

				// делаем запрос на поиск в QA
				// URL по умолчанию
				let _url = this.QAURL + '/api2panel/search'

				// производим сам запрос формы
				this.$http.post(_url, Helper.toFormData({ search: txt })).then(
					// успешно получили данные
					res => {
						if (res && typeof res === 'object' && res.ok === true && res.body && res.body.status)
							EventBus.$emit('form-ticket-serach-result', res.body.answer)
						else
							EventBus.$emit('form-ticket-serach-result', false)
					},
					// не успешный результат
					res => {
						EventBus.$emit('form-ticket-serach-result', false)
					}
				)
			}
		},
		//---------------------------------------------------------------------
		// событие общей шины - смена языка
		//---------------------------------------------------------------------
		handleLang() {
			this.qaSearchEvent()

			// сбросим кеш вопросов
			this.$store.commit('setQACache', null)

			// после этого будет уничтожение компонента,
			// так как перестраивается всё приложение
			// и при создании компонента будет новый запрос
		}

		//---------------------------------------------------------------------
	},
	//=========================================================================
	// наблюдатель
	//=========================================================================
	watch: {
		// если изменился выбранный язык
		'currentLang': function() {
			this.handleLang()
		}
	},
	//=========================================================================
	// используемые компоненты
	//=========================================================================
	components: {
		Field
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
.qa-search-field-title {
	margin: 20px 0 0;
}

.qa-tags-cloud-title {
	margin: 10px 0 20px 0;
}

.support-block-wrapper {
	display: flex;
	display: -webkit-box;
	display: -webkit-flex;

	justify-content: center;
	-webkit-justify-content: center;

	margin: 20px 0 40px 0;
}

.support-block-wrapper.search {
	margin: 0;	
}

.w5-support-link {
	display: inline-block;
	text-align: center;
	margin-right: 10px;
	width: 240px;
	height: 100px;
	border: 1px solid #eee;
	border-radius: 4px;
	font-size: 20px;
	font-weight: 400;
	transition: border-color 0.2s;
}

.w5-support-link:hover {
	border-color: #2880da;
}
.w5-application.mc .w5-support-link:hover {
	border-color: #3250ba;
}

.w5-support-link svg.svg-inline--fa {
	margin-top: 10px;
	font-size: 40px;
	width: 100%;
}

.w5-support-link .header {
	position: relative;
	display: inline-block;
	top: -5px;
	font-size: 15px;
	color: #555;
	width: 100%;
	transition: all ease-in .15s;
}

.w5-support-link .link-title {
	position: relative;
	display: inline-block;
	top: -10px;
	font-size: 13px;
	font-weight: 300;
	width: 100%;

	opacity: 0;
	transition: all ease-in .15s, opacity ease-in .2s;	
}

.w5-support-link:hover .header {
    top: -10px;
}

.w5-support-link:hover .link-title {
    top: -20px;
    opacity: 1;
}

.support-block-questions {
	padding: 0 10px 0 0;
	width: 50%;
}

.support-block-questions h4 {
	margin-top: 0;
}

.support-block-questions ul {
	padding: 0;
	margin: 0;
	list-style: none;
}

.support-block-questions li {
	line-height: 1.2;
	padding: 10px 0;
	font-size: 14px;
	font-weight: 300;
}

.support-tag-cloud {
	position: relative;
	top: -7px;
	width: 100%;
}

.support-tag-cloud .tag {
	margin-top: 4px;
    display: inline-block;
    position: relative;
    margin-right: 18px;
}

.support-tag-cloud .tag > a {
    font-size: 11px;
    color: #666;
    border-radius: 3px;
    padding: 2px 6px;
    background: #f0f0f0;
    transition: all 0.1s 0.01s ease-in;
}

.support-tag-cloud .tag > a:hover {
    color: #fff;
    background-color: #3ba3ff;
}

.w5-application.mc .support-tag-cloud .tag > a:hover {
    background-color: #1b379c;
}

@media (max-width: 767px) {
	.support-block-wrapper {
		text-align: center; 
		flex-direction: column;
	}

	.support-block-wrapper.search {
		text-align: left;
	}

	.w5-support-link {
		margin: 10px auto;
	}

	.support-tag-cloud {
		text-align: center;
	}

	.support-block-questions {
		text-align: left;
		padding: 0;
		width: 100%;
	}

	.support-block-questions.first {
		margin-bottom: 30px;
	}
}

</style>



// WEBPACK FOOTER //
// QA.vue?bf4d32be